import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/push-center';

const getConfig = (merchantId, sourceType, pushType, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${sourceType}/${pushType}/channel-config`,
		payload
	);
};

const connect = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/channel-config`, payload);
};

const disconnect = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/channel-config/${id}`, payload);
};

const xeroOauth = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/xero-oauth`, payload);
};

const setXeroTenant = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/set-xero-tenant`, payload);
};

export default { getConfig, connect, disconnect, xeroOauth, setXeroTenant };
